import React from "react"
import {Button} from 'primereact/button';
import {Dialog} from "primereact/dialog";
import {FormSectionElements, FormSections, FormSubSections, LOVValues} from "../../entities/formTemplateDataType";
import {Dropdown} from "primereact/dropdown";
import { MultiSelect } from "primereact/multiselect";
import {Checkbox} from "primereact/checkbox";
import {DialogBase, Props} from "./DialogBase";
import {getFieldByName, getFilterFieldValues, getOtherFieldOptions, getRootComponent, isInputElement} from "../../utilities/ElementUtils";
import {odsButtonClassList} from "../../entities/Constants";
import { InputText } from "primereact/inputtext";
import { InputTextarea } from "primereact/inputtextarea";
interface State {
    pickedFieldOptions;
}

export class DialogForDefaultComponent extends DialogBase<Props,State>  {
    dateTypeFieldList = [];
    expectedValueOptions = []
    constructor(props: Props) {
        super(props);
        this.state = {
            pickedFieldOptions: [],
        }

        let subSection = this.props.ele.parent as FormSubSections;
        this.dateTypeFieldList = subSection.ListOfFormSectionElements?.filter(p => p.Datatype === 'Date' && p.Sequence < this.props.ele.Sequence);

            console.log(this.props.ele.Datatype )
        
        if (this.props.ele.Datatype === "RadioButton" && this.props.ele.ListOfLOVValues?.length) {
            this.expectedValueOptions = [{ label: 'Select a expected value', labelFRA: 'Sélectionnez une valeur attendue', val: '' as string | boolean }]
                .concat(
                    this.props.ele.ListOfLOVValues
                        .map(item => {
                            let value: string | boolean = item.code;
                            if (item.convertToBoolean) {
                                if (value === "true") value = true;
                                else if (value === "false") value = false;
                            }
                            return {
                                label: item.description, 
                                labelFRA: item.FRADescription, 
                                val: value
                            };
                        })
                );
        }
        if (isInputElement(this.props.ele)) {
            this.props.ele.input = {...this.props.ele.input ?? {}, submitCollect: this.props.ele.input?.submitCollect ?? true};
        }
    }

    componentDidMount(): void {
        if (this.props.ele.FilterField) {
            const filterField = getFieldByName(this.props.ele.FilterField, this.props.ele);
            const filterValues = getFilterFieldValues(filterField);
            this.setState({ pickedFieldOptions: filterValues });
        }
    }
    
    getSummaryListColumnOptions = () => {
        const options = [{
            label: this.props.isEng ? 'No summary list filter' : 'Pas de filtre summary list',
            value: null
        }];

        const root = getRootComponent(this.props.ele);
        const sections = root?.ListOfFormSections ?? [];

        sections.forEach((section: FormSections) => {
            section?.ListOfFormSubSections?.forEach((subSection: FormSubSections) => {
                subSection?.ListOfFormSectionElements?.forEach((element: FormSectionElements) => {
                        if ((element?.Datatype === "SummaryList" || element?.Datatype === "PagedSummaryList") && element.subSectionList?.length) {
                        const summaryTitle = this.props.isEng ? element.ENUTitle : element.FRATitle;
                            const summaryId = element.Id;
                        const columns = element.subSectionList[0]?.ListOfFormSectionElements ?? [];
                        columns.forEach((column: FormSectionElements) => {
                            const columnKey = column?.LoadBindName;
                            if (!columnKey) return;
                            const columnTitle = this.props.isEng ? column.ENUTitle : column.FRATitle;
                            options.push({
                                    label: `${summaryTitle || summaryId || 'Summary List'} - ${columnTitle || columnKey}`,
                                    value: `${summaryId}|${columnKey}`
                            });
                        });
                    }
                });
            });
        });

        const unique = new Map<string, { label: string; value: string | null }>();
        options.forEach(option => {
            const key = option.value === null ? 'null' : String(option.value);
            if (!unique.has(key)) {
                unique.set(key, option);
            }
        });

        return Array.from(unique.values());
    }

    getDropdownFieldOptions = () => {
        const options: { label: string; value: string | null }[] = [{
            label: this.props.isEng ? 'No column selector' : 'Pas de sélecteur de colonne',
            value: null
        }];

        const root = getRootComponent(this.props.ele);
        const sections = root?.ListOfFormSections ?? [];

        const traverseElements = (elements: FormSectionElements[]) => {
            elements?.forEach((element: FormSectionElements) => {
                if (element?.Datatype === "Dropdown" && element.Id !== this.props.ele.Id) {
                    const elementTitle = this.props.isEng ? element.ENUTitle : element.FRATitle;
                    options.push({
                        label: `${elementTitle || element.LoadBindName || element.Id}`,
                        value: element.Id
                    });
                }
                // Search inside nested elements (Row, etc.)
                if (element?.subSectionList?.length) {
                    element.subSectionList.forEach(sub => {
                        if (sub?.ListOfFormSectionElements) {
                            traverseElements(sub.ListOfFormSectionElements);
                        }
                    });
                }
            });
        };

        sections.forEach((section: FormSections) => {
            section?.ListOfFormSubSections?.forEach((subSection: FormSubSections) => {
                if (subSection?.ListOfFormSectionElements) {
                    traverseElements(subSection.ListOfFormSectionElements);
                }
            });
        });

        return options;
    }

    onChangeHanlder = (newValue) => {
        this.props.ele.FilterField = newValue;
        let currentSection = this.props.ele.parent.parent.Datatype==='Row'? this.props.ele.parent.parent.parent.parent : this.props.ele.parent.parent as FormSections;
        let currentSubSeq = this.props.ele.parent.parent.Datatype==='Row'? this.props.ele.parent.parent.parent.Sequence: this.props.ele.parent.Sequence;
        let totalOption = [];
        let eleListPrior = [];
        if(this.props.ele.parent.parent.Datatype==='Row'){
            let currentSection = this.props.ele.parent.parent.parent.parent as FormSections;
            let currentSubSeq = this.props.ele.parent.parent.parent.Sequence;
            currentSection.ListOfFormSubSections.filter(sub=>sub.Sequence<=currentSubSeq).forEach((sub) => {
                sub.ListOfFormSectionElements.forEach(ele=>{
                    if(ele.Datatype==='Row'&&ele.subSectionList){
                        ele.subSectionList[0].ListOfFormSectionElements.forEach(el=>{
                            if(sub.Sequence<this.props.ele.parent.parent.parent.Sequence || ele.Sequence==this.props.ele.parent.parent.Sequence&&el.Sequence<this.props.ele.Sequence || ele.Sequence<this.props.ele.parent.parent.Sequence){
                                eleListPrior.push(el)
                            }
                        })
                    }else{
                        if(sub.Sequence<this.props.ele.parent.parent.parent.Sequence || ele.Sequence<this.props.ele.parent.parent.Sequence){
                            eleListPrior.push(ele)
                        }
                    }
                })
            })
        }else{
            let currentSection = this.props.ele.parent.parent as FormSections;
            let currentSubSeq = this.props.ele.parent.Sequence;
            currentSection.ListOfFormSubSections.filter(sub=>sub.Sequence<=currentSubSeq).forEach((sub) => {
                sub.ListOfFormSectionElements.forEach(ele=>{
                    if(ele.Datatype==='Row'&&ele.subSectionList){
                        ele.subSectionList[0].ListOfFormSectionElements.forEach(el=>{
                            if(sub.Sequence<this.props.ele.parent.Sequence || ele.Sequence<this.props.ele.Sequence){
                                eleListPrior.push(el)
                            }
                        })
                    }else{
                        if(sub.Sequence<this.props.ele.parent.Sequence || ele.Sequence<this.props.ele.Sequence){
                            eleListPrior.push(ele)
                        }
                    }
                })
            })
        }

            //let eleListPrior = sub.ListOfFormSectionElements.filter(p => p.Sequence < this.props.ele.Sequence|| sub.Sequence<this.props.ele.parent.Sequence);
            let pickedFieldOptions = eleListPrior.filter(ele => ele.LoadBindName?.replace(/\s/g, "") == newValue)
                .map(q => {
                    const container = {};
                    if (q.Datatype == "Checkbox") {
                        const yLOVValue = new LOVValues();
                        yLOVValue.code = "Y";
                        yLOVValue.description = "Y";
                        const nLOVValue = new LOVValues();
                        nLOVValue.code = "N";
                        nLOVValue.description = "N";
                        container[q.LoadBindName] = [yLOVValue, nLOVValue];
                    } else {
                        container[q.LoadBindName] = q.ListOfLOVValues;
                    }
                    return container;
                });
            totalOption.push(...pickedFieldOptions);
        
        this.setState({ pickedFieldOptions: totalOption });
        this.props.callback();
    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Field Properties for " + this.props.ele.ENUTitle : "Field Properties for " + this.props.ele.FRATitle}
                    footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }}
                    onHide={() => this.props.callback(false)}
                >
                    {this.otherPreviousDateFields()}
                </Dialog>
            </>
        );
        return html;
    }

    otherPreviousDateFields = () => {
        let htmlString = [];
        const summaryElement = this.props.ele as any;
        const summaryFilterSelection = summaryElement?.filterSummaryListId
            ? (Array.isArray(summaryElement.filterSummaryListColumns) && summaryElement.filterSummaryListColumns.length
                ? summaryElement.filterSummaryListColumns.map((col: string) => `${summaryElement.filterSummaryListId}|${col}`)
                : (summaryElement.filterSummaryListColumn ? [`${summaryElement.filterSummaryListId}|${summaryElement.filterSummaryListColumn}`] : []))
            : [];

        htmlString.push(
            <div>
                {this.scriptHtml()}
                {this.updateBindingFieldHtml()}

                {this.listValuesApiHtml()}
                {this.searchAutoCompleteHtml()}

                {this.questionHintHtml()}

                {this.renderHighlightFieldErrorToggle()}

                {this.emptyErrorMessageHtml()}

                {this.errorMessageHtml()}
                
                {this.enableRichTextErrorMessage()}

                {this.richTextErrorMessageHtml()}

                {(this.props.ele.Datatype === "RadioButton" && this.props.ele.ListOfLOVValues?.length) && 
                    this.expectedValueHtml()
                }

                {(this.props.ele.Datatype === "RadioButton") && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"convert_to_boolean_" + this.props.ele.Sequence}>Convert to Boolean:</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox 
                                id={"convert_to_boolean_" + this.props.ele.Sequence}
                                onChange={(e) => { 
                                    // Apply to all LOV values
                                    if (this.props.ele.ListOfLOVValues) {
                                        this.props.ele.ListOfLOVValues.forEach(lov => {
                                            lov.convertToBoolean = e.checked;
                                        });
                                    }
                                    this.props.callback();
                                }} 
                                checked={this.props.ele.ListOfLOVValues?.[0]?.convertToBoolean ?? false}
                            />
                        </div>
                    </div>
                )}
                {/* Show Popup field for "RadioButton"/"RadioButtonWithRichText"/"DeleteSubsectionButton"/"Button" */}
                {(this.props.ele.Datatype === "RadioButton" || this.props.ele.Datatype === "RadioButtonWithRichText" || this.props.ele.Datatype === "DeleteSubsectionButton") && (
                    <>
                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                        <div style={{ width: '25%' }}>Show Popup</div>
                        <div style={{ alignItems: 'center', marginTop: '5px' }}>
                            <Checkbox
                                checked={!!this.props.ele.ShowPopup}
                                value={this.props.ele.ShowPopup}
                                className='p-checkbox'
                                title="Show confirmation popup when changing selection"
                                onChange={(e) => {
                                    this.props.ele.ShowPopup = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                    {(this.props.ele.ShowPopup) && (
                        <>
                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Popup Title (EN)</div>
                                <div style={{ width: '60%' }}>
                                    <InputText
                                        className="ontario-input"
                                        value={this.props.ele.PopupTitle || ''}
                                        onChange={(e) => {
                                            this.props.ele.PopupTitle = e.target.value || undefined;
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Popup Title (FR)</div>
                                <div style={{ width: '60%' }}>
                                    <InputText
                                        className="ontario-input"
                                        value={this.props.ele.PopupTitleFRA || ''}
                                        onChange={(e) => {
                                            this.props.ele.PopupTitleFRA = e.target.value || undefined;
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Popup Title Icon</div>
                                <div style={{ width: '60%' }}>
                                    <InputText
                                        className="ontario-input"
                                        value={this.props.ele.PopupDialogConfigs?.PopupMessageIcon || ''}
                                        onChange={(e) => {
                                            this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupTitleFRA: e.target.value}
                                            this.props.callback();
                                        }}
                                        />
                                    </div>
                            </div>
                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Popup Message (EN)</div>
                                <div style={{ width: '60%' }}>
                                    <InputTextarea
                                        className="ontario-input"
                                        value={this.props.ele.PopupMessage || ''}
                                        onChange={(e) => {
                                            this.props.ele.PopupMessage = e.target.value;
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>
                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Popup Message (FR)</div>
                                <div style={{ width: '60%' }}>
                                    <InputTextarea
                                        className="ontario-input"
                                        value={this.props.ele.PopupMessageFRA || ''}
                                        onChange={(e) => {
                                            this.props.ele.PopupMessageFRA = e.target.value;
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>

                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Left Button Class</div>
                                <div style={{ width: '60%' }}>
                                    <Dropdown showClear options={odsButtonClassList} optionLabel='label' optionValue='val' value={this.props.ele.PopupDialogConfigs?.PopupLeftButtonClassName}
                                        onChange={(e) => {
                                            this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupLeftButtonClassName: e.target.value}
                                            this.props.callback();
                                        }}
                                    ></Dropdown>
                                </div>
                            </div>
                                            
                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Left Button Text (EN)</div>
                                <div style={{ width: '60%' }}>
                                    <InputText
                                        className="ontario-input"
                                        value={this.props.ele.PopupSaveButtonText || this.props.ele.PopupDialogConfigs?.PopupLeftButtonText || ''}
                                        onChange={(e) => {
                                            this.props.ele.PopupSaveButtonText = e.target.value || undefined;
                                            this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupLeftButtonText: e.target.value}
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>
    
                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Left Button Text (FR)</div>
                                <div style={{ width: '60%' }}>
                                    <InputText
                                        className="ontario-input"
                                        value={this.props.ele.PopupSaveButtonTextFRA || this.props.ele.PopupDialogConfigs?.PopupLeftButtonTextFRA || ''}
                                        onChange={(e) => {
                                            this.props.ele.PopupSaveButtonTextFRA = e.target.value || undefined;
                                            this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupLeftButtonTextFRA: e.target.value}
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>
                                            
                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Right Button Class</div>
                                <div style={{ width: '60%' }}>
                                    <Dropdown showClear options={odsButtonClassList} optionLabel='label' optionValue='val' value={this.props.ele.PopupDialogConfigs?.PopupRightButtonClassName}
                                        onChange={(e) => {
                                            this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupRightButtonClassName: e.target.value}
                                            this.props.callback();
                                        }}
                                    ></Dropdown>
                                </div>
                            </div>

                            <div style={{ display: "flex", marginTop: '10px' }}>
                                <div style={{ width: '25%' }}>Right Button Text (EN)</div>
                                <div style={{ width: '60%' }}>
                                    <InputText
                                        className="ontario-input"
                                        value={this.props.ele.PopupCancelButtonText || this.props.ele.PopupDialogConfigs?.PopupRightButtonText || ''}
                                        onChange={(e) => {
                                            this.props.ele.PopupCancelButtonText = e.target.value || undefined;
                                            this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupRightButtonText: e.target.value}
                                            this.props.callback();
                                        }}
                                    />
                                </div>
                            </div>
                    
                                    <div style={{ display: "flex", marginTop: '10px' }}>
                                        <div style={{ width: '25%' }}>Right Button Text (FR)</div>
                                        <div style={{ width: '60%' }}>
                                            <InputText
                                                className="ontario-input"
                                                value={this.props.ele.PopupCancelButtonTextFRA || this.props.ele.PopupDialogConfigs?.PopupRightButtonTextFRA || ''}
                                                onChange={(e) => {
                                                    this.props.ele.PopupCancelButtonTextFRA = e.target.value || undefined;
                                                    this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupRightButtonTextFRA: e.target.value}
                                                    this.props.callback();
                                                }}
                                            />
                                        </div>
                                    </div>
            
                                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                                        <div style={{ width: '25%' }}>Modal dialog?</div>
                                        <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                            <Checkbox 
                                                checked={this.props.ele.PopupDialogConfigs?.ModalDialog || false} 
                                                value={this.props.ele.PopupDialogConfigs?.ModalDialog}
                                                className='p-checkbox' 
                                                title="Is modal dialog"
                                                onChange={(e) => {
                                                    this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, ModalDialog: e.checked}
                                                    this.props.callback();
                                                }} 
                                            />
                                        </div>
                                    </div>
            
                                    <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                                        <div style={{ width: '25%' }}>Closable?</div>
                                        <div style={{ alignItems: 'center', marginTop: '5px' }}>
                                            <Checkbox 
                                                checked={this.props.ele.PopupDialogConfigs?.PopupCloseable || false} 
                                                value={this.props.ele.PopupDialogConfigs?.PopupCloseable}
                                                className='p-checkbox' 
                                                title="Popup is closable"
                                                onChange={(e) => {
                                                    this.props.ele.PopupDialogConfigs = {...this.props.ele.PopupDialogConfigs, PopupCloseable: e.checked}
                                                    this.props.callback();
                                                }} 
                                            />
                                        </div>
                                    </div>
                                    </>
                )}
                    </>
                )}

                {this.tooTipHtml()}

                {this.hintExpansionTitleHtml()}
                {this.props.ele.Datatype === "RadioButton" &&
                (
                    <div>
                        {this.hintExpansionContentHtml()} 
                        {this.hintExpansionBelowElementLabelHtml()}
                    </div>
                )}
            
                {this.calloutBoxHtml()}
                {this.fieldSizeHtml()}

                <div style={{ display:  "flex",  marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Field</div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Dropdown options={getOtherFieldOptions(this.props.ele)} style={{width:'100%'}}
                            className="ontario-dropdown-small"
                            optionLabel="description"
                            optionValue="code"
                            value={this.props.ele.FilterField}
                            onChange={(e) => {
                                this.onChangeHanlder(e.value);}
                            }
                        />
                    </div>
                </div>
                <div style={{ display:  "flex" , marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>Filtering Value</div>
                    <div style={{ width: '60%', marginTop: '5px' }}>
                        <div>
                            {/* @ts-ignore */}
                            <Dropdown style={{width:'100%'}}
                                className="ontario-dropdown-small"
                                options={this.state.pickedFieldOptions[0] ? this.state.pickedFieldOptions[0][this.props.ele.FilterField] : null}
                                value={this.props.ele.FilterValue}
                                optionLabel="description"
                                optionValue="code"
                                placeholder="Filtering value"
                                onChange={(e) => {
                                    this.props.ele.FilterValue = e.value;
                                    //this.props.isEng ? (this.props.ele.FilterValue = e.value) : (this.props.ele.FilterValueFRA = e.value);
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                </div>
                {this.props.ele.Datatype === "SearchAutocomplete" && (
                    <>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={`summary_list_filter_${this.props.ele.Sequence}`}>Summary list filter</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <MultiSelect
                                id={`summary_list_filter_${this.props.ele.Sequence}`}
                                className="ontario-dropdown-small"
                                optionLabel="label"
                                optionValue="value"
                                options={this.getSummaryListColumnOptions()}
                                value={summaryFilterSelection}
                                placeholder="Select summary list columns"
                                style={{ width: '100%' }}
                                display="chip"
                                onChange={(e) => {
                                    const elementAny = this.props.ele as any;
                                    const rawValues = e.value ?? [];
                                    const selectedValues: string[] = (Array.isArray(rawValues) ? rawValues : [rawValues]).filter(v => typeof v === 'string');
                                    if (!selectedValues.length) {
                                        elementAny.filterSummaryListId = null;
                                        elementAny.filterSummaryListColumn = null;
                                        elementAny.filterSummaryListColumns = [];
                                        this.props.callback();
                                        return;
                                    }
                                    const [firstSummaryId] = selectedValues[0].split('|');
                                    const scopedValues = selectedValues.filter(v => v.startsWith(`${firstSummaryId}|`));
                                    const columnNames = scopedValues.map(val => val.split('|')[1]).filter(Boolean);
                                    elementAny.filterSummaryListId = firstSummaryId;
                                    elementAny.filterSummaryListColumns = columnNames;
                                    elementAny.filterSummaryListColumn = columnNames[0] ?? null;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={`filter_column_selector_${this.props.ele.Sequence}`}>Column selector dropdown</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Dropdown
                                id={`filter_column_selector_${this.props.ele.Sequence}`}
                                className="ontario-dropdown-small"
                                optionLabel="label"
                                optionValue="value"
                                options={this.getDropdownFieldOptions()}
                                value={(this.props.ele as any).filterColumnSelectorId ?? null}
                                placeholder="Select a dropdown for dynamic column"
                                style={{ width: '100%' }}
                                showClear
                                onChange={(e) => {
                                    const elementAny = this.props.ele as any;
                                    elementAny.filterColumnSelectorId = e.value ?? null;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                    </>
                )}

                {this.indentHtml()}
                {this.maskSummaryHtml()}

                {this.props.ele.Datatype === "TableSummary" && (
                    <div style={{ display: "flex", marginTop: '10px', alignItems: 'center' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"hideChangeLink_" + this.props.ele.Sequence}>
                                Hide "Change" link in summary:
                            </label>
                        </div>
                        <div style={{ width: '60%' }}>
                            <Checkbox 
                                id={"hideChangeLink_" + this.props.ele.Sequence}
                                checked={this.props.ele.HideChangeLink || false}
                                onChange={(e) => {
                                    this.props.ele.HideChangeLink = e.checked;
                                    this.props.callback();
                                }}
                            />
                        </div>
                    </div>
                )}

                {this.fieldOnTopHtml()}

                <div style={{ display: "flex", marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"show_optional_label_" + this.props.ele.Sequence}>Show Optional/Required Label:</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        {/* @ts-ignore */}
                        <Checkbox value={this.props.ele.showOptionalLabel ?? true} 
                            id={"show_optional_label_" + this.props.ele.Sequence}
                            onChange={(e) => { 
                                this.props.ele.showOptionalLabel = e.checked; 
                                this.props.callback() 
                            }} 
                            checked={this.props.ele.showOptionalLabel ?? true}
                        />
                    </div>
                </div>

                <div style={{ display: "flex", marginTop: '10px', marginBottom: '10px' }}>
                    <div style={{ width: '25%' }}>Length in Pixel:</div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                        <InputText className='ontario-input' disabled={this.props.isEng == false} placeholder='Length in px' title="style width in pixel for the Number field" 
                            value={this.props.ele.LengthInPixel}
                            onChange={(e) => {
                                this.props.ele.LengthInPixel = e.target.value;
                                this.props.callback();
                            }} />
                        </div>
                </div>
                {isInputElement(this.props.ele) && (
                    <div style={{ display: "flex", marginTop: '10px' }}>
                        <div style={{ width: '25%' }}>
                            <label htmlFor={"collect_submit" + this.props.ele.Sequence}>Collect for submit:</label>
                        </div>
                        <div style={{ width: '60%' }}>
                            {/* @ts-ignore */}
                            <Checkbox value={this.props.ele.input?.submitCollect} 
                                id={"collect_submit" + this.props.ele.Sequence}
                                onChange={(e) => { 
                                    this.props.ele.input = {...this.props.ele.input ?? {}, submitCollect: e.checked}; 
                                    this.props.callback() 
                                }} 
                                checked={this.props.ele.input?.submitCollect}
                            />
                        </div>
                    </div>
                )}

                {this.excludeFromPayload()}
                {this.InitialVisibility()}
            </div>
        )

        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
